import { v4 as uuidv4 } from "uuid";

import { abortAndGetNewSignal, createKey } from "./abort";

export const generateCorrelationId = () => uuidv4() as string;

export const addFetchInterceptor = () => {
  const { fetch: originalFetch } = window;

  window.fetch = async (...args) => {
    const [resource, config] = args;

    if (config && config.headers) {
      let correlationId = sessionStorage.getItem("correlationId");
      if (!correlationId) {
        correlationId = generateCorrelationId();
        sessionStorage.setItem("correlationId", correlationId);
      }

      (config.headers["x-correlation-id"] as unknown) = correlationId;

      config.signal = abortAndGetNewSignal(
        createKey(config.method ?? "GET", resource.toString())
      );
    }

    return await originalFetch(resource, config);
  };
};
